export default __webpack_public_path__ + "static/media/TEXTURA_04.bb12f4c7.png";